/**
 * Sincroniza o identificador da sessão na URL via parâmetro hcid.
 * Usa history.replaceState — sem reload, pushState ou navegação.
 */
export function syncHcidToUrl(sessionId: string): void {
  if (typeof window === 'undefined' || !sessionId) return;

  try {
    const url = new URL(window.location.href);
    // if (url.searchParams.has('hcid')) return;

    url.searchParams.set('hcid', sessionId);
    window.history.replaceState(window.history.state, '', url.toString());
  } catch {
    // ignore URL parsing errors
  }
}

/**
 * Gera identificador de sessão curto e único (sem prefixo session_).
 */
export function generateShortSessionId(): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 10);
  return `${timestamp}${random}`;
}
